import Splide from '@splidejs/splide';

const EL = '.js-show'
const ACTIVE_CLASS = 'is-active'

if (document.querySelector(EL)) {
  const slider = new Splide( EL, {
    type: 'fade',
    rewind: false,
    perPage: 1,
    autoplay: true,
    interval: 5000,
    pagination: true,
    arrows: true,
    height: '510px',
  } ).mount();
}
